/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ShiftReportStatus {
  Open = 'Open',
  Closed = 'Closed'
}
